import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class OpenHours extends Component {
  render() {
    return (
      <EntityList apiRoute='api/openhours' title="Heures d'ouverture" editTitle="Heures d'ouverture" displayColumns={[
        {Description: 'Jour', Column: 'Day'},
        {Description: "Heures d'ouverture", Column: 'OpenHour'},
        {Description: 'Heures de fermeture', Column: 'CloseHour'},
        {Description: 'Fermé', Column: 'Closed', sortable: false},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default OpenHours;



/** WEBPACK FOOTER **
 ** ./src/app/routes/general/openHours.js
 **/